/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Machine_Id_Copied_ToastInputs */



/**
* | output |
* | --- |
* | "Machine Id copied to clipboard successfully." |
*
* @param {Login_Offline_Machine_Id_Copied_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_machine_id_copied_toast = /** @type {((inputs?: Login_Offline_Machine_Id_Copied_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Machine_Id_Copied_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identifiant machine copie dans le presse-papiers.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Maschinen-ID wurde erfolgreich in die Zwischenablage kopiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID macchina copiato correttamente negli appunti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор машины успешно скопирован в буфер обмена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Id. de la máquina copiada al portapapeles exitosamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("机器ID已成功复制到剪贴板。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マシン ID がクリップボードに正常にコピーされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मशीन आईडी सफलतापूर्वक क्लिपबोर्ड पर कॉपी हो गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID da máquina copiado com sucesso para a área de transferência.")
	return /** @type {LocalizedString} */ ("Machine Id copied to clipboard successfully.")
});